<template>
  <div>
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <h2 class="brand-text text-primary ml-1">
              TRED
            </h2>
          </b-link>
            <h1 class="auth-title">{{ $t('Регистрация') }}</h1>
              <validation-observer
                  ref="loginForm"
                  #default="{invalid}"
              >
                <b-form @submit="sendSignUp($event)" id="registration"  class="auth-login-form mt-2">
                  <div class="message_box"></div>
                  <b-form-group
                      :label-for="$t('Имя')"
                      label="name"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                    >
                      <b-form-input
                          id="name"
                          v-model="name"
                          name="name"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Akram"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                      :label-for="'Еmail'"
                      label="email"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="email"
                        rules="email"
                    >
                      <b-form-input
                          id="email"
                          v-model="username"
                          name="email"
                          :state="errors.length > 0 ? false:null"
                          placeholder="email"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                      :label-for="$t('Пароль')"
                      label="password"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="password"
                        rules="required"
                    >
                      <b-form-input
                          id="password"
                          v-model="password"
                          name="password"
                          :state="errors.length > 0 ? false:null"
                          placeholder="password"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                      :label-for="$t('Подтвердите пароль')"
                      label="password"
                  >
                    <validation-provider
                        #default="{ errors }"
                        name="password2"
                        rules="required"
                    >
                      <b-form-input
                          id="password2"
                          v-model="passwordConfirmation"
                          name="password2"
                          :state="errors.length > 0 ? false:null"
                          placeholder="password"
                          type="password"
                          autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <span class="error inner-error">
          {{ err }}
        </span>
                  <b-button
                      class="mb-2"
                      variant="primary"
                      type="submit"
                      block
                      :disabled="invalid"
                  >
                    {{$t('Регистрация')}}
                  </b-button>

                </b-form>
              </validation-observer>
              <span class="authorize-button">
                {{ $t('Уже зарегистрированы') }}?
                <router-link to="/login">{{ $t('Авторизация') }}</router-link>
              </span>
        </b-card>
      </div>
    </div>

  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BLink,
} from 'bootstrap-vue'
import {required, email} from '@validations'
import {createNamespacedHelpers} from 'vuex';
import setPreloader from "@/mixins/setPreloader";

const {mapActions} = createNamespacedHelpers('user');

export default {
  name: 'index',
  data() {
    return {
      name: '',
      username: '',
      password: '',
      passwordConfirmation: '',
      err: '',
      required,
      email,
    };
  },
  mixins: [setPreloader],
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    ...mapActions(['signUp', 'getUser']),
    sendSignUp($event) {
      $event.preventDefault();
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.openPrealoder()
          if (this.password !== this.passwordConfirmation) {
            this.$bvToast.toast(this.$t('Пароли не совпадают'), {
              title: this.$t('Пароли не совпадают'),
              variant: 'danger',
              solid: true,
            })
          }
          const signUpData = {
            name: this.name,
            email: this.username,
            password: this.password,
            password_confirmation: this.passwordConfirmation,
            device_name: 'browser',
          };
          this.signUp(signUpData)
              .then((res) => {
                if (res.status === 200) {
                  this.getUser()
                      .then((res) => {
                        this.$router.push('/');
                      });
                }
              })
              .catch((err) => {
                if (err.response.data.errors.email[0] === 'validation.unique') {
                  this.$bvToast.toast('Этот email уже зарегистрирован в системе', {
                    title: `Ошибка! Введите другой email`,
                    variant: 'danger',
                    solid: true,
                  })
                } else {
                  this.$bvToast.toast('Проверьте правильность введенных данных', {
                    title: `Ошибка! Проверьте введенные данные`,
                    variant: 'danger',
                    solid: true,
                  })
                }
              })
              .finally(() => {
                this.closePreloader();
              });
        }
      })


    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
